import { Typography } from '@pmi.web/react-common';
import { useTranslation } from 'react-i18next';

import { HelpSlide } from '../HelpSlide';

export function SlideShare() {
  const { t } = useTranslation();

  return (
    <HelpSlide>
      <svg
        width="56"
        height="46"
        viewBox="0 0 56 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.1567 15.5636C53.202 15.2864 53.1865 15.0027 53.1113 14.7321C53.0361 14.4615 52.9029 14.2105 52.7211 13.9965C52.5393 13.7825 52.3131 13.6105 52.0582 13.4926C51.8033 13.3747 51.5259 13.3135 51.245 13.3135H4.74501C4.46417 13.3135 4.1867 13.3747 3.93182 13.4926C3.67694 13.6105 3.45075 13.7825 3.26891 13.9965C3.08708 14.2105 2.95394 14.4615 2.87873 14.7321C2.80352 15.0027 2.78804 15.2864 2.83335 15.5636L6.77293 39.648C7.04504 41.3112 7.89959 42.8235 9.18393 43.9148C10.4683 45.0061 12.0987 45.6052 13.7841 45.6051H42.2059C43.8913 45.6052 45.5218 45.0061 46.8061 43.9148C48.0904 42.8235 48.945 41.3112 49.2171 39.648L53.1567 15.5636ZM48.9639 17.1885L45.3912 39.0228C45.2674 39.7785 44.8792 40.4656 44.2958 40.9615C43.7123 41.4574 42.9716 41.7298 42.2059 41.7301H13.7841C13.0184 41.7298 12.2777 41.4574 11.6943 40.9615C11.1108 40.4656 10.7226 39.7785 10.5988 39.0228L7.0261 17.1885H48.9639Z"
          fill="#061423"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.1565 14.2535L37.4065 1.33682C37.1394 0.901713 36.7114 0.589612 36.2155 0.468352C35.7195 0.347092 35.1958 0.426474 34.7581 0.689244C34.3203 0.952014 34.004 1.37693 33.8779 1.87164C33.7517 2.36634 33.8259 2.89085 34.0843 3.33115L41.8343 16.2478C42.1014 16.6829 42.5295 16.995 43.0254 17.1163C43.5213 17.2375 44.0451 17.1582 44.4828 16.8954C44.9205 16.6326 45.2368 16.2077 45.363 15.713C45.4891 15.2183 45.4149 14.6938 45.1565 14.2535ZM14.1565 16.2478L21.9065 3.33115C22.1649 2.89085 22.2391 2.36634 22.113 1.87164C21.9868 1.37693 21.6705 0.952014 21.2328 0.689244C20.7951 0.426474 20.2713 0.347092 19.7754 0.468352C19.2795 0.589612 18.8514 0.901713 18.5843 1.33682L10.8343 14.2535C10.5759 14.6938 10.5017 15.2183 10.6279 15.713C10.754 16.2077 11.0703 16.6326 11.5081 16.8954C11.9458 17.1582 12.4695 17.2375 12.9655 17.1163C13.4614 16.995 13.8894 16.6829 14.1565 16.2478ZM26.0579 24.2923V34.6256C26.0579 35.1395 26.2621 35.6323 26.6254 35.9957C26.9888 36.359 27.4816 36.5631 27.9954 36.5631C28.5093 36.5631 29.0021 36.359 29.3654 35.9957C29.7288 35.6323 29.9329 35.1395 29.9329 34.6256V24.2923C29.9329 23.7785 29.7288 23.2856 29.3654 22.9223C29.0021 22.5589 28.5093 22.3548 27.9954 22.3548C27.4816 22.3548 26.9888 22.5589 26.6254 22.9223C26.2621 23.2856 26.0579 23.7785 26.0579 24.2923ZM15.7246 24.2923V34.6256C15.7246 35.1395 15.9287 35.6323 16.2921 35.9957C16.6554 36.359 17.1482 36.5631 17.6621 36.5631C18.1759 36.5631 18.6688 36.359 19.0321 35.9957C19.3955 35.6323 19.5996 35.1395 19.5996 34.6256V24.2923C19.5996 23.7785 19.3955 23.2856 19.0321 22.9223C18.6688 22.5589 18.1759 22.3548 17.6621 22.3548C17.1482 22.3548 16.6554 22.5589 16.2921 22.9223C15.9287 23.2856 15.7246 23.7785 15.7246 24.2923ZM36.3913 24.2923V34.6256C36.3913 35.1395 36.5954 35.6323 36.9587 35.9957C37.3221 36.359 37.8149 36.5631 38.3288 36.5631C38.8426 36.5631 39.3354 36.359 39.6988 35.9957C40.0621 35.6323 40.2663 35.1395 40.2663 34.6256V24.2923C40.2663 23.7785 40.0621 23.2856 39.6988 22.9223C39.3354 22.5589 38.8426 22.3548 38.3288 22.3548C37.8149 22.3548 37.3221 22.5589 36.9587 22.9223C36.5954 23.2856 36.3913 23.7785 36.3913 24.2923Z"
          fill="#061423"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.8299 13.3135H2.16322C1.64936 13.3135 1.15655 13.5176 0.7932 13.881C0.429848 14.2443 0.225719 14.7371 0.225719 15.251C0.225719 15.7648 0.429848 16.2576 0.7932 16.621C1.15655 16.9843 1.64936 17.1885 2.16322 17.1885H53.8299C54.3437 17.1885 54.8366 16.9843 55.1999 16.621C55.5633 16.2576 55.7674 15.7648 55.7674 15.251C55.7674 14.7371 55.5633 14.2443 55.1999 13.881C54.8366 13.5176 54.3437 13.3135 53.8299 13.3135Z"
          fill="#061423"
        />
      </svg>

      <div
        style={{
          marginTop: 'var(--pmi-spacing-md)',
        }}
      >
        <Typography variant="h1">{t('Share')}</Typography>
      </div>
      <div
        style={{
          marginTop: 'var(--pmi-spacing-xs)',
        }}
      >
        <Typography variant="p">
          {t(
            'Create your basket* in the Share Baskets section, add products and share your customised baskets with multiple customers.',
          )}
        </Typography>
      </div>
      <div
        style={{
          marginTop: 'var(--pmi-spacing-xs)',
        }}
      >
        <Typography variant="small">
          {t(
            '*You can create as many baskets as you like and share them with as many customers as you like.',
          )}
        </Typography>
      </div>
    </HelpSlide>
  );
}
